import { render, staticRenderFns } from "./AvaliacaoTopico.vue?vue&type=template&id=46dc911f&scoped=true&"
import script from "./AvaliacaoTopico.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoTopico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc911f",
  null
  
)

export default component.exports